import React from 'react';
import { CheckSquare, Calendar, Clock } from 'lucide-react';
import type { Task } from '../../types';

interface TaskSummaryProps {
  tasks: Task[];
}

export function TaskSummary({ tasks }: TaskSummaryProps) {
  const now = new Date();
  const formattedDate = now.toLocaleDateString('en-US', {
    weekday: 'short',
    month: 'short',
    day: 'numeric'
  });
  const formattedTime = now.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  });

  const openTasks = tasks.filter(task => 
    task.status !== 'done' && 
    !task.archived
  ).length;
  
  const highPriorityTasks = tasks.filter(task =>
    task.status !== 'done' &&
    !task.archived &&
    task.priority === 'high'
  ).length;

  return (
    <div className="mb-1">
      <div className="bg-[#0a8d8d] rounded-xl p-4 shadow-lg">
        <div className="flex items-center justify-between mb-2">
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-2">
              <Calendar className="w-4 h-4 text-white" />
              <span className="text-sm text-white">{formattedDate}</span>
            </div>
            <div className="flex items-center gap-2">
              <Clock className="w-4 h-4 text-white" />
              <span className="text-sm text-white">{formattedTime}</span>
            </div>
          </div>
          <CheckSquare className="w-5 h-5 text-white" />
        </div>
        <h2 className="text-base font-medium text-white mb-1">Your Updates</h2>
        <div className="flex items-baseline gap-2 pb-2 border-b border-white/20">
          <h2 className="text-lg font-semibold text-white">You have {openTasks} tasks</h2>
          {highPriorityTasks > 0 && (
            <span className="px-2 py-1 bg-red-100 text-red-600 text-sm rounded-lg">
              {highPriorityTasks} High
            </span>
          )}
          <span className="text-white">for today</span>
        </div>
        <div className="flex items-center gap-6 mt-3 text-sm">
          <div className="flex items-center gap-2">
            <span className="text-white">Work:</span>
            <span className="font-medium text-white">{tasks.filter(t => t.role === 'work' && t.status !== 'done' && !t.archived).length}</span>
          </div>
          <div className="flex items-center gap-2">
            <span className="text-white">Personal:</span>
            <span className="font-medium text-white">{tasks.filter(t => t.role === 'personal' && t.status !== 'done' && !t.archived).length}</span>
          </div>
          <div className="flex items-center gap-2">
            <span className="text-white">Family:</span>
            <span className="font-medium text-white">{tasks.filter(t => t.role === 'family' && t.status !== 'done' && !t.archived).length}</span>
          </div>
        </div>
      </div>
    </div>
  );
}